import { useContext, useState, useEffect, useRef, CSSProperties, useMemo } from 'react';
import { Box } from "@mui/material";
import './chatseaction.css';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { dataContext, prevUser, user } from '../context/userContect.js';
import User_Image from './images/User_image.png';
import Ai_image from './images/Robot_ai_image.jpg';
// import LinearProgress from '@mui/material/LinearProgress';
import Grid from '@mui/material/Grid2';
import { Link } from 'react-router-dom';
import CopyAllOutlinedIcon from '@mui/icons-material/CopyAllOutlined';
import CheckIcon from '@mui/icons-material/Check';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import StopCircleRoundedIcon from '@mui/icons-material/StopCircleRounded';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import TopicRoundedIcon from '@mui/icons-material/TopicRounded';
import { HashLoader } from "react-spinners";
// import Riple from 'react-ripple-loader';
// import { GoArrowRight } from "react-icons/go";
// import ImageIcon from '@mui/icons-material/Image';
// import TerminalIcon from '@mui/icons-material/Terminal';
// import TerminalRoundedIcon from '@mui/icons-material/TerminalRounded';
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded';
import { fetchDeepseekResponse } from './deepseekApi';
import { fetchClaudeResponse } from './claudeApi';

// Add these utility functions at the top of the file after imports
const stripHtmlTags = (html) => {
    if (!html) return '';

    try {
        // Create a temporary div element
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Get all text nodes and join them with appropriate spacing
        const textContent = [];
        const walk = document.createTreeWalker(
            tempDiv,
            NodeFilter.SHOW_TEXT,
            null,
            false
        );

        let node;
        while (node = walk.nextNode()) {
            textContent.push(node.textContent.trim());
        }

        return textContent
            .filter(text => text.length > 0)
            .join(' ')
            .replace(/\s+/g, ' ')
            .trim();
    } catch (error) {
        console.error('Error stripping HTML tags:', error);
        // Fallback to basic string replacement if DOM manipulation fails
        return html
            .replace(/<[^>]*>/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }
};

// Add this function before the Chatseaction component
const formatAIResponse = (text) => {
    if (!text) return '';

    // Add basic syntax highlighting for code
    const applyCodeSyntaxHighlighting = (code, language) => {
        // Skip syntax highlighting for unknown languages
        if (!language || language === 'plaintext' || language === 'text') {
            return code;
        }

        // Basic syntax highlighting for common languages
        let highlightedCode = code
            // Strings
            .replace(/(["'`])(.*?)\1/g, '<span class="code-string">$1$2$1</span>')
            // Comments
            .replace(/(\/\/.*?)(?:\n|$)/g, '<span class="code-comment">$1</span>')
            .replace(/(\/\*[\s\S]*?\*\/)/g, '<span class="code-comment">$1</span>')
            // Keywords
            .replace(/\b(function|return|if|else|for|while|class|const|let|var|import|export|from|async|await|try|catch|new|this)\b/g,
                '<span class="code-keyword">$1</span>')
            // Numbers
            .replace(/\b(\d+(\.\d+)?)\b/g, '<span class="code-number">$1</span>')
            // Function names
            .replace(/\b([a-zA-Z_$][a-zA-Z0-9_$]*)\s*\(/g, '<span class="code-function">$1</span>(')
            // Types (first-pass for known types)
            .replace(/\b(String|Number|Boolean|Array|Object|Promise|Date|RegExp|Map|Set)\b/g,
                '<span class="code-type">$1</span>');

        return highlightedCode;
    };

    // Handle code blocks first - match ```language code ``` pattern
    text = text.replace(/```([\w-]*)([\s\S]*?)```/g, (match, language, code) => {
        language = language.trim();
        code = code.trim();

        // Apply syntax highlighting if language is specified
        const highlightedCode = applyCodeSyntaxHighlighting(code, language);

        // Create a code block container with language indicator and copy button
        return `<div class="code-block-container">
            <div class="code-language">${language || 'plaintext'}</div>
            <pre class="code-block">${highlightedCode}</pre>
            <button class="code-copy-btn" onclick="copyCode(this)">
                <span class="copy-icon">📋</span>
            </button>
        </div>`;
    });

    // Handle inline code with backticks
    text = text.replace(/`([^`]+)`/g, '<code>$1</code>');

    // Split into lines for processing
    let lines = text.split('\n');
    let formattedLines = [];
    let inList = false;
    let listType = null;
    let listItems = [];
    let inTable = false;
    let tableContent = '';
    let inSteps = false;

    for (let i = 0; i < lines.length; i++) {
        let line = lines[i].trim();

        // Skip empty lines
        if (!line) {
            if (inList) {
                // End current list
                formattedLines.push(listType === 'ol' ?
                    `<ol class="ai-list">${listItems.join('')}</ol>` :
                    `<ul class="ai-list">${listItems.join('')}</ul>`);
                inList = false;
                listItems = [];
            } else if (inTable) {
                // End current table
                formattedLines.push(`<div class="table-container">${tableContent}</div>`);
                inTable = false;
                tableContent = '';
            } else {
                formattedLines.push('<div class="ai-paragraph-break"></div>');
            }
            continue;
        }

        // Handle tables
        if (line.includes('|') && (line.match(/\|/g) || []).length >= 2) {
            if (!inTable) {
                inTable = true;
                tableContent = '<table class="ai-table">';
            }

            // Check if it's a delimiter row
            if (line.replace(/[\s\-|]/g, '') === '') {
                continue;  // Skip the delimiter row
            }

            // Process the table row
            const cells = line.split('|').filter(cell => cell.trim() !== '');
            let rowContent = '<tr>';

            cells.forEach(cell => {
                // Determine if it's a header row based on first row or cell formatting
                const isHeader = tableContent.includes('<tr>') === false || cell.trim().startsWith('**');
                const cellContent = cell.trim().replace(/^\*\*(.*)\*\*$/, '$1');
                rowContent += isHeader ? `<th>${cellContent}</th>` : `<td>${cellContent}</td>`;
            });

            rowContent += '</tr>';
            tableContent += rowContent;
            continue;
        } else if (inTable) {
            // End table if line doesn't match table pattern
            formattedLines.push(`<div class="table-container">${tableContent}</table></div>`);
            inTable = false;
            tableContent = '';
        }

        // Handle headings
        if (line.startsWith('# ')) {
            formattedLines.push(`<h1 class="ai-heading">${line.substring(2)}</h1>`);
            continue;
        } else if (line.startsWith('## ')) {
            formattedLines.push(`<h2 class="ai-heading">${line.substring(3)}</h2>`);
            continue;
        } else if (line.startsWith('### ')) {
            formattedLines.push(`<h3 class="ai-heading">${line.substring(4)}</h3>`);
            continue;
        }

        // Handle steps format (1. Step title style)
        const stepMatch = line.match(/^(\d+)\.\s+(.+)/);
        if (stepMatch && !line.match(/^\d+\.\s+\d+\./)) {
            // Check if this is a step format 
            const number = stepMatch[1];
            const content = stepMatch[2];

            // End any previous list
            if (inList) {
                formattedLines.push(listType === 'ol' ?
                    `<ol class="ai-list">${listItems.join('')}</ol>` :
                    `<ul class="ai-list">${listItems.join('')}</ul>`);
                inList = false;
                listItems = [];
            }

            formattedLines.push(`<div class="ai-step">
                <div class="ai-step-number">${number}</div>
                <div class="ai-step-content">
                    <h3 class="ai-step-title">${content}</h3>
                </div>
            </div>`);
            inSteps = true;
            continue;
        }

        // Continue step content if we're in steps mode
        if (inSteps && !stepMatch && !line.match(/^[•\-\*]\s+/) && !line.match(/^\d+[\.\)]\s+/)) {
            // This is content that belongs to the previous step
            // Add it inside the last div 
            const lastElement = formattedLines[formattedLines.length - 1];
            if (lastElement && lastElement.includes('ai-step-content')) {
                // Process the content for strong, em, etc.
                line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
                line = line.replace(/\*(.*?)\*/g, '<em>$1</em>');

                // Replace the last element with the updated content
                formattedLines[formattedLines.length - 1] = lastElement.replace('</div>', `<p class="ai-step-description">${line}</p></div>`);
                continue;
            }
        }

        // Handle list items (bullets)
        if (line.match(/^[•\-\*]\s+/)) {
            if (!inList || listType !== 'ul') {
                // End previous list if it was a different type
                if (inList) {
                    formattedLines.push(listType === 'ol' ?
                        `<ol class="ai-list">${listItems.join('')}</ol>` :
                        `<ul class="ai-list">${listItems.join('')}</ul>`);
                    listItems = [];
                }
                inList = true;
                listType = 'ul';
                inSteps = false;
            }

            // Format list item
            let itemContent = line.replace(/^[•\-\*]\s+/, '');

            // Process formatting
            itemContent = itemContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            itemContent = itemContent.replace(/\*(.*?)\*/g, '<em>$1</em>');

            listItems.push(`<li class="ai-list-item">${itemContent}</li>`);
            continue;
        }

        // Handle numbered list items
        if (line.match(/^\d+[\.\)]\s+/)) {
            if (!inList || listType !== 'ol') {
                // End previous list if it was a different type
                if (inList) {
                    formattedLines.push(listType === 'ol' ?
                        `<ol class="ai-list">${listItems.join('')}</ol>` :
                        `<ul class="ai-list">${listItems.join('')}</ul>`);
                    listItems = [];
                }
                inList = true;
                listType = 'ol';
                inSteps = false;
            }

            // Format numbered list item
            let itemContent = line.replace(/^\d+[\.\)]\s+/, '');

            // Check if it's a main point (make it bold)
            if (!line.match(/^\d+\.\d+/)) { // Not a sub-point
                itemContent = `<strong>${itemContent}</strong>`;
            }

            // Process formatting within the item
            itemContent = itemContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            itemContent = itemContent.replace(/\*(.*?)\*/g, '<em>$1</em>');

            listItems.push(`<li class="ai-list-item">${itemContent}</li>`);
            continue;
        }

        // Handle sub-points (indented items)
        if (line.match(/^\s+[•\-\*]\s+/)) {
            let itemContent = line.trim().replace(/^[•\-\*]\s+/, '');

            // Process formatting
            itemContent = itemContent.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
            itemContent = itemContent.replace(/\*(.*?)\*/g, '<em>$1</em>');

            listItems.push(`<li class="ai-list-item ai-sub-item">${itemContent}</li>`);
            continue;
        }

        // Regular paragraph
        if (inList) {
            formattedLines.push(listType === 'ol' ?
                `<ol class="ai-list">${listItems.join('')}</ol>` :
                `<ul class="ai-list">${listItems.join('')}</ul>`);
            inList = false;
            listItems = [];
        }

        // Handle bold and italic
        line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
        line = line.replace(/\*(.*?)\*/g, '<em>$1</em>');

        formattedLines.push(`<p class="ai-paragraph">${line}</p>`);
    }

    // Add any remaining list items
    if (inList) {
        formattedLines.push(listType === 'ol' ?
            `<ol class="ai-list">${listItems.join('')}</ol>` :
            `<ul class="ai-list">${listItems.join('')}</ul>`);
    }

    // Add any remaining table
    if (inTable) {
        formattedLines.push(`<div class="table-container">${tableContent}</table></div>`);
    }

    return formattedLines.join('');
};

function Chatseaction() {

    let {
        sent,
        input,
        setInput,
        showResult,
        setShowResult,
        resultData,
        setResultData,
        recentPrompt,
        setRecentPropmt,
        loading,
        setLoading,
        // handleCopy,
        // copied,
        // speakText,
        // isSpeaking,
        handleKeyDown,
        setPopUp,
        popUp,
        feature,
        setFeature,
        handleImage,
        prevFeature,
        setPrevFeature,
        genImgUrl,
        popUps,
        setPopUps,
    } = useContext(dataContext);

    // State for Copy and Read buttons
    const [isCopied, setIsCopied] = useState(false);
    const [isReading, setIsReading] = useState(false);
    const [selectedTool, setSelectedTool] = useState('chatbox'); // 'chatbox', 'deepseek', 'claude'
    const [typingResponse, setTypingResponse] = useState('');
    const [isTyping, setIsTyping] = useState(false);
    const [typingCompleted, setTypingCompleted] = useState(false); // Track if typing animation was completed
    const [lastResultData, setLastResultData] = useState(''); // Track the last result data
    const [hasNavigatedAway, setHasNavigatedAway] = useState(false); // Track if user navigated away

    // Refs for speech synthesis
    const speechSynthesisRef = useRef(null);

    // Track page visibility to detect navigation
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // User navigated away or minimized the page
                setHasNavigatedAway(true);
            }
        };

        // Track when user navigates away using beforeunload
        const handleBeforeUnload = () => {
            setHasNavigatedAway(true);
        };

        // Track when user returns to the page
        const handleFocus = () => {
            // User returned to the page - don't reset hasNavigatedAway immediately
            // We'll handle this in the typing effect logic
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('focus', handleFocus);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    // Function to determine typing speed based on content length
    const getTypingSpeed = (text) => {
        if (!text) return 15;
        
        const length = text.length;
        
        // Short text (less than 200 characters) - normal speed
        if (length < 200) {
            return 15;
        }
        // Medium text (200-500 characters) - slightly faster
        else if (length < 500) {
            return 10;
        }
        // Long text (500-1000 characters) - faster
        else if (length < 1000) {
            return 8;
        }
        // Very long text (1000+ characters) - much faster
        else {
            return 5;
        }
    };

    // Add mobile scroll management
    useEffect(() => {
        // Function to scroll chat to bottom on new messages
        const scrollToBottom = () => {
            const chatContainer = document.querySelector('.topsecation');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        };

        // Scroll when a new message is added or when loading completes
        if (showResult && !loading) {
            setTimeout(scrollToBottom, 100); // Small delay to ensure content is rendered
        }

        // Handle mobile viewport adjustments for input focus
        const handleInputFocus = () => {
            // On mobile, scroll the container to make sure the input is visible
            setTimeout(() => {
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
            }, 200);
        };

        const textArea = document.querySelector('.custom-textarea');
        if (textArea) {
            textArea.addEventListener('focus', handleInputFocus);

            return () => {
                textArea.removeEventListener('focus', handleInputFocus);
            };
        }
    }, [showResult, loading, resultData]);

    // Add copy code function
    const copyCode = (button) => {
        try {
            // Find the closest code block container
            const codeBlockContainer = button.closest('.code-block-container');
            if (!codeBlockContainer) return;

            // Get the code block element
            const codeBlock = codeBlockContainer.querySelector('.code-block');
            if (!codeBlock) return;

            // Get the text content of the code block
            const text = codeBlock.innerText || codeBlock.textContent;

            if (text) {
                // Try using the Clipboard API first
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(() => {
                        // Change button icon temporarily to show success
                        const icon = button.querySelector('.copy-icon');
                        if (icon) {
                            const originalText = icon.textContent;
                            icon.textContent = '✓';
                            setTimeout(() => {
                                icon.textContent = originalText;
                            }, 2000);
                        }
                    }).catch(err => {
                        console.error('Failed to copy code with Clipboard API:', err);
                        // Use fallback method
                        copyCodeFallback(text, button);
                    });
                } else {
                    // Use fallback for browsers without Clipboard API
                    copyCodeFallback(text, button);
                }
            }
        } catch (error) {
            console.error('Error copying code:', error);
        }
    };

    // Fallback method for copying code
    const copyCodeFallback = (text, button) => {
        try {
            // Create temporary element
            const textArea = document.createElement('textarea');
            textArea.value = text;

            // Make it non-visible
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            document.body.appendChild(textArea);

            // Select and copy
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');
            document.body.removeChild(textArea);

            if (successful) {
                // Show success indicator
                const icon = button.querySelector('.copy-icon');
                if (icon) {
                    const originalText = icon.textContent;
                    icon.textContent = '✓';
                    setTimeout(() => {
                        icon.textContent = originalText;
                    }, 2000);
                }
            }
        } catch (err) {
            console.error('Fallback code copy failed:', err);
        }
    };

    // Add to window object to make it accessible from the HTML
    window.copyCode = copyCode;

    // Improved copy text function for the footer Copy button
    const handleCopyText = () => {
        if (!resultData) return;

        const responseElement = document.querySelector('.formatted-response');
        if (responseElement) {
            const textToCopy = stripHtmlTags(responseElement.innerHTML);

            if (textToCopy) {
                // Try using the Clipboard API first
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(textToCopy)
                        .then(() => {
                            setIsCopied(true);
                            setTimeout(() => {
                                setIsCopied(false);
                            }, 2000);
                        })
                        .catch(error => {
                            console.error('Failed to copy text with Clipboard API:', error);
                            // Fallback to element method
                            copyTextFallback(textToCopy);
                        });
                } else {
                    // Use fallback method for browsers without Clipboard API
                    copyTextFallback(textToCopy);
                }
            }
        }
    };

    // Fallback copy method using temporary textarea element
    const copyTextFallback = (text) => {
        try {
            // Create a temporary textarea element
            const textArea = document.createElement('textarea');
            textArea.value = text;

            // Make it non-visible
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.width = '2em';
            textArea.style.height = '2em';
            textArea.style.padding = '0';
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';
            textArea.style.background = 'transparent';
            document.body.appendChild(textArea);

            // Select and copy the text
            textArea.focus();
            textArea.select();

            const successful = document.execCommand('copy');

            // Clean up
            document.body.removeChild(textArea);

            if (successful) {
                setIsCopied(true);
                setTimeout(() => {
                    setIsCopied(false);
                }, 2000);
            } else {
                console.error('Fallback copy method failed');
            }
        } catch (err) {
            console.error('Fallback copy method error:', err);
        }
    };

    // Improved speak function for the footer Read button
    const handleSpeakText = () => {
        if (!resultData || isReading) {
            // If already reading, stop it
            if (isReading && window.speechSynthesis) {
                window.speechSynthesis.cancel();
                setIsReading(false);
                return;
            }
            return;
        }

        const responseElement = document.querySelector('.formatted-response');
        if (responseElement) {
            const textToSpeak = stripHtmlTags(responseElement.innerHTML);

            if (textToSpeak && window.speechSynthesis) {
                // Cancel any ongoing speech
                window.speechSynthesis.cancel();

                // Create a new speech synthesis utterance
                const utterance = new SpeechSynthesisUtterance(textToSpeak);

                // Set properties
                utterance.lang = 'en-US';
                utterance.rate = 1.0;
                utterance.pitch = 1.0;

                // Set handlers
                utterance.onstart = () => {
                    setIsReading(true);
                };

                utterance.onend = () => {
                    setIsReading(false);
                };

                utterance.onerror = () => {
                    setIsReading(false);
                };

                // Store reference to allow stopping
                speechSynthesisRef.current = utterance;

                // Start speaking
                window.speechSynthesis.speak(utterance);
            }
        }
    };

    // Typing animation effect for AI response with dynamic speed and navigation handling
    useEffect(() => {
        if (!resultData || loading) {
            setTypingResponse('');
            setIsTyping(false);
            return;
        }

        // Check if this is the same result data that was already typed
        if (resultData === lastResultData && typingCompleted) {
            // Skip animation, show full response immediately
            setTypingResponse(resultData);
            setIsTyping(false);
            return;
        }

        // If user has navigated away and returned, skip typing animation
        if (resultData === lastResultData && hasNavigatedAway) {
            setTypingResponse(resultData);
            setIsTyping(false);
            setTypingCompleted(true);
            setHasNavigatedAway(false); // Reset the flag
            return;
        }

        // If it's the same result but typing wasn't completed, also skip animation
        // This handles cases where user returns from another page
        if (resultData === lastResultData && !typingCompleted) {
            setTypingResponse(resultData);
            setIsTyping(false);
            setTypingCompleted(true);
            return;
        }

        // New result data, start typing animation
        if (resultData !== lastResultData) {
            setLastResultData(resultData);
            setTypingCompleted(false);
            setHasNavigatedAway(false); // Reset navigation flag for new content
        }

        let i = 0;
        setTypingResponse('');
        setIsTyping(true);
        const text = resultData;
        
        // Get dynamic typing speed based on content length
        const typingSpeed = getTypingSpeed(text);
        
        const interval = setInterval(() => {
            setTypingResponse(prev => prev + text[i]);
            i++;
            if (i >= text.length) {
                clearInterval(interval);
                setIsTyping(false);
                setTypingCompleted(true); // Mark typing as completed
            }
        }, typingSpeed); // Use dynamic typing speed
        
        return () => clearInterval(interval);
    }, [resultData, loading, hasNavigatedAway]);

    // Reset typing completion when a new request starts (loading becomes true)
    useEffect(() => {
        if (loading) {
            setTypingCompleted(false);
            setTypingResponse('');
            setIsTyping(false);
            setHasNavigatedAway(false); // Reset navigation flag when starting new request
        }
    }, [loading]);

    // Memoize the typing response to prevent unnecessary re-renders
    const displayResponse = useMemo(() => {
        if (isTyping) {
            return typingResponse;
        }
        return resultData;
    }, [isTyping, typingResponse, resultData]);

    // Modified send handler to use selected tool
    const handleSendMessage = async () => {
        if (!input.trim()) return;
        
        setTypingResponse('');
        setIsTyping(false);
        setTypingCompleted(false); // Reset typing completion for new message
        setHasNavigatedAway(false); // Reset navigation flag for new message
        
        if (selectedTool === 'chatbox') {
            // Use existing Google API logic from context
            sent(input);
        } else {
            // Handle Deepseek and Claude APIs - mirror the sent() function logic
            try {
                // Start the same state management as sent() function
                setResultData("");
                setPrevFeature(feature);
                setShowResult(true);
                setRecentPropmt(input);
                setLoading(true);
                
                let aiResponse = '';
                
                // Prepare image data if available
                let imageData = null;
                if (user.data && user.mime_type) {
                    imageData = {
                        imageData: user.data,
                        mimeType: user.mime_type
                    };
                }
                
                if (selectedTool === 'deepseek') {
                    aiResponse = await fetchDeepseekResponse(input, imageData);
                } else if (selectedTool === 'claude') {
                    aiResponse = await fetchClaudeResponse(input, imageData);
                }
                
                // Update result data
                setResultData(aiResponse);
                
                // Store previous user data (same as in sent function)
                if (user.data && user.mime_type) {
                    prevUser.data = user.data;
                    prevUser.mime_type = user.mime_type;
                    prevUser.imgUrl = user.imgUrl;
                    prevUser.prompt = input;

                    // Reset current user data
                    user.data = null;
                    user.mime_type = null;
                    user.imgUrl = null;
                }
                
                // Clear input
                setInput('');
                
                // Reset feature to chat
                setFeature("chat");
                
            } catch (error) {
                console.error('Error with selected AI tool:', error);
                setResultData(`Error: ${error.message}`);
            } finally {
                // End loading
                setLoading(false);
            }
        }
        
        // Scroll to bottom after sending
        setTimeout(() => {
            const chatContainer = document.querySelector('.topsecation');
            if (chatContainer) {
                chatContainer.scrollTop = chatContainer.scrollHeight;
            }
        }, 100);
    };

    // Expose setResultData for non-context tools
    useEffect(() => {
        window.setResultData = (data) => {
            if (typeof setResultData === 'function') setResultData(data);
        };
        return () => { window.setResultData = null; };
    }, []);

    return (

        <Box className="chatseaction1">

            <Box className='topsecation'>

                {!showResult ?

                    <Box className='headings'>

                        <span>I'm Developed By ChatBox AI,</span>
                        <span>I'm Your Own Assistant</span>
                        <span>What can I help you with?</span>

                    </Box> : <Box className='result'>

                        <Box className='userbox'>

                            <pre className='main_set'>

                                {prevFeature === "upimg" ?

                                    <>

                                        <Grid container spacing={0}>

                                            <Grid size={{ xs: 12, md: 12, lg: 12 }} className='main_set'>

                                                <img src={prevUser.imgUrl} alt='Uploaded Image' />

                                            </Grid>

                                        </Grid>

                                        <p>{recentPrompt}</p>
                                    </>
                                    :
                                    <p>{recentPrompt}</p>
                                }

                            </pre>

                            <img src={User_Image} alt='User' />

                        </Box>

                        <Box className='aibox'>

                            <img src={Ai_image} alt='AI' />

                            {loading ?

                                <Box className='loader'>

                                    <HashLoader
                                        color="#d0d0d0"
                                        cssOverride={{}}
                                        loading
                                        size={20}
                                        speedMultiplier={1}
                                    />

                                    {/* <Riple color="#c7c7c7" size="small" text="" textColor="#a9a9a9" /> */}

                                    {/* <LinearProgress color="secondary" />
                                    <LinearProgress color="secondary" />
                                    <LinearProgress color="secondary" /> */}

                                </Box> :

                                <Grid container spacing={0}>

                                    <Grid size={{ xs: 12, md: 12, lg: 12 }} >

                                        <pre className="ai_reply">
                                            {prevFeature === "genimg" ?
                                                <>
                                                    {!genImgUrl ?
                                                        <Box className='loader'>
                                                            {/* <LinearProgress color="secondary" />
                                                            <LinearProgress color="secondary" />
                                                            <LinearProgress color="secondary" /> */}
                                                            <HashLoader
                                                                color="#d0d0d0"
                                                                cssOverride={{}}
                                                                loading
                                                                size={20}
                                                                speedMultiplier={1}
                                                            />
                                                        </Box>
                                                        :
                                                        <Grid container spacing={0}>

                                                            <Grid size={{ xs: 12, md: 12, lg: 12 }} className='main_set'>

                                                                <img src={genImgUrl} alt='Generated Image' />

                                                            </Grid>

                                                        </Grid>
                                                    }
                                                </>
                                                :
                                                !resultData ?
                                                    <Box className='loader'>
                                                        {/* <LinearProgress color="secondary" />
                                                        <LinearProgress color="secondary" />
                                                        <LinearProgress color="secondary" /> */}
                                                        <HashLoader
                                                            color="#d0d0d0"
                                                            cssOverride={{}}
                                                            loading
                                                            size={20}
                                                            speedMultiplier={1}
                                                        />
                                                    </Box>
                                                    :
                                                    <>
                                                        <div className="ai-response-container">
                                                            <div
                                                                className="formatted-response"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: formatAIResponse(isTyping ? typingResponse : resultData)
                                                                }}
                                                            />
                                                            {isTyping && (
                                                                <span className="typing-cursor">|</span>
                                                            )}

                                                            <div className="ai-response-actions">
                                                                <button
                                                                    onClick={handleCopyText}
                                                                    className={`ai-action-btn copy-btn ${isCopied ? 'copied' : ''}`}
                                                                >
                                                                    <span className="ai-action-icon">
                                                                        {isCopied ?
                                                                            <CheckIcon fontSize="small" /> :
                                                                            <CopyAllOutlinedIcon fontSize="small" />
                                                                        }
                                                                    </span>
                                                                    <span className="ai-action-text">
                                                                        {isCopied ? 'Copied' : 'Copy'}
                                                                    </span>
                                                                </button>

                                                                <button
                                                                    onClick={handleSpeakText}
                                                                    className={`ai-action-btn read-btn ${isReading ? 'speaking' : ''}`}
                                                                >
                                                                    <span className="ai-action-icon">
                                                                        {isReading ?
                                                                            <StopCircleRoundedIcon fontSize="small" /> :
                                                                            <VolumeUpRoundedIcon fontSize="small" />
                                                                        }
                                                                    </span>
                                                                    <span className="ai-action-text">
                                                                        {isReading ? 'Stop' : 'Read'}
                                                                    </span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </>
                                            }
                                        </pre>

                                    </Grid>

                                </Grid>

                            }

                        </Box>

                    </Box>
                }

            </Box>

            <Box className='bottomsecation'>
                <Box className="input-container">
                    <textarea
                        className="custom-textarea"
                        placeholder="Type your message here..."
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />

                    <Box className="action-buttons" style={{ display: 'flex', alignItems: 'center' }}>



                        <Box className="action-buttons-2">
                            {user && user.imgUrl && <img src={user.imgUrl} alt='User avatar' className="user-avatar" />}

                            <button className="btn" title="Language options">
                                <LanguageOutlinedIcon />
                            </button>

                            {/* <Box> */}

                            <Box position="relative">
                                <button
                                    className="btn"
                                    onClick={() => setPopUp(prev => !prev)}
                                    title={feature === "genimg" ? "AI Generate Image" : "Image Options"}
                                >
                                    {feature === "genimg" ? <AutoAwesomeRoundedIcon /> : <ImageOutlinedIcon />}
                                </button>
                            </Box>



                            {/* </Box> */}

                            <Box position="relative">

                                <button
                                    className="btn"
                                    onClick={() => setPopUps(prev => !prev)}
                                    title="Menu Options"
                                >
                                    <MenuRoundedIcon />
                                </button>
                            </Box>

                            {/* Tool selector dropdown */}
                            <select
                                className="ai-tool-selector"
                                value={selectedTool}
                                onChange={e => setSelectedTool(e.target.value)}
                                style={{ marginRight: 8, height: 36, borderRadius: 6 }}
                            >
                                <option value="chatbox">ChatBox</option>
                                <option value="deepseek">Deepseek v3</option>
                                <option value="claude">Claude 3.7 Sonnet</option>
                            </select>
                        </Box>
                        {/* Send button */}
                        <Box className="action-buttons-3">
                            {input && (
                                <button
                                    className="btn"
                                    onClick={handleSendMessage}
                                    title="Send Message"
                                    style={{ marginLeft: 0 }}
                                >
                                    <SendRoundedIcon />
                                </button>
                            )}
                        </Box>
                    </Box>
                </Box>
                <Box>
                    {popUp && (
                        <Box className='pop-up'>


                            <Box className='select-gen'>
                                <button onClick={() => {
                                    setPopUp(false)
                                    setFeature("chat")
                                    document.getElementById("inputImg").click()
                                }}>
                                    <TopicRoundedIcon />
                                    Upload Image
                                </button>
                            </Box>

                            {/* <Box className='select-up'>
                                <button onClick={() => {
                                    setPopUp(false)
                                    setFeature("genimg")
                                }}>
                                    <AutoAwesomeRoundedIcon />
                                    Image Generate V1
                                </button>
                            </Box> */}

                            <Box>
                                <Link to='/Aimagev2' className='select-up' style={{ textDecoration: 'none' }}>
                                    <button onClick={() => setPopUps(false)}>
                                        <AutoAwesomeRoundedIcon />
                                        Image Generate 
                                    </button>
                                </Link>
                            </Box>

                        </Box>
                    )}
                </Box>
                <Box>
                    {popUps && (
                        <Box className='pop-up1'>
                            <Box>
                                <Link to='/Humanizetext' className='select-up' style={{ textDecoration: 'none' }}>
                                    <button onClick={() => setPopUps(false)}>
                                        <AutoAwesomeRoundedIcon />
                                        Humanize Text
                                    </button>
                                </Link>
                            </Box>

                            <Box className='select-gen'>
                                <Link to='/AiVideoGen' className='select-up' style={{ textDecoration: 'none' }}>
                                    <button onClick={() => setPopUps(false)}>
                                        <PlayCircleRoundedIcon />
                                        AI Video Generate
                                    </button>
                                </Link>
                            </Box>

                            {/* <Box className='select-gen2'>
                                <Link to='/websiteDesigning' className='select-up' style={{ textDecoration: 'none' }}>
                                    <button onClick={() => setPopUps(false)}>
                                        <TerminalIcon />
                                        website Designing   
                                    </button>
                                </Link>
                            </Box> */}

                        </Box>
                    )}
                </Box>
                {/* {genImgUrl && <img src={genImgUrl} alt="Generated" id="send_img" />} */}
                
                {/* Hidden file input for multiple file types */}
                <input
                    type="file"
                    id="inputImg"
                    accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.html,.htm,.css,.js,.jsx,.ts,.tsx,.py,.java,.cpp,.c,.cs,.php,.rb,.go,.rs,.swift,.kt,.json,.xml,.yaml,.yml,.md,.sql,.sh,.bat,.csv"
                    style={{ display: 'none' }}
                    onChange={handleImage}
                />
            </Box>
        </Box>

    )

}

export default Chatseaction
